import React from "react";
import { AiOutlineCheckCircle } from "react-icons/ai";
import { useSelector } from "react-redux";
import styles from "./Thanks.module.css";
import Order from "../Order/Order";

function Thanks() {
  const user = useSelector((state) => state.user);

  return (
    <>
      <div className={styles.main + " container"}>
        <div>
          <p className={styles.orderCreated}>
            Orden ingresada con éxito{" "}
            <AiOutlineCheckCircle style={{ fontSize: "1.2rem" }} />
          </p>
          <h2 className="text-muted fs-1 fw-bold">Gracias por su compra</h2>
          <p className="text-muted">
            Apreciamos su pedido, estamos actualmente trabajando en él. Le
            confirmaremos por correo a la brevedad!
          </p>
        </div>
        <hr className={styles.lines} />
        <Order order={user.lastOrder} />
      </div>
    </>
  );
}

export default Thanks;
